<header>
  <div class="barra-azul transparent">
    <div class="container">
      <div class="row">
        <div class="col-6">
          <!-- This content will take up 3/12 (or 1/4) of the container -->

        </div>
        <div class="col-6">
          <div class="menuTopoDireita"> <span class="telefone">
              <img src="../../assets/fone.png" alt="telefone">
               0800 061 3040</span>
            <span class="spacer">|</span> <span class="pontoAtendimento">
                  <a href="http://www.poupex.com.br/atendimento/pontos-de-atendimento">
                  Clique aqui e encontre o Ponto de Atendimento mais próximo</a>
                </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="top-header barra-branca">
    <nav class="navbar navbar-expand-lg navbar-light bg-light" style="margin-top: -7px;">
      <div class="container">
        <a class="navbar-brand p-0" href="/">
          <img class="logo-barra-poupex" src="../../assets/logo-PD.png" alt="Logo Poupex"/>
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01"
                aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation"
                (click)="isShow = !isShow">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" [ngClass]="{'show' : isShow}" id="navbarTogglerDemo01">
          <!--MENU DE INFORMAÇÕES DO USUÁRIO-->
          <ul class="navbar-nav mr-auto p-0 navbar-row ui-g" *ngIf="isUsuarioRoute">
            <li class="nav-item  ui-sm-12">
              <a class="nav-link">{{titulo}}</a>
            </li>
          </ul>
          <ul class="navbar-nav mr-auto p-0 navbar-row ui-g" *ngIf="!isUsuarioRoute">
            <li class="nav-item ui-sm-12">
              <span class="nav-label">Simulação</span>
            </li>
            <li class="nav-item  ui-sm-12">
              <a class="nav-link" routerLink="/simulacao/credito-imobiliario"
                 routerLinkActive="active" (click)="isShow = !isShow">Crédito Imobiliário</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</header>
